<template>
  <div class="questions" v-if="survey[$route.params.survey]">
    <app-qaheader></app-qaheader>
    <div class="card">
      <div class="card-middle" :style="{ height: qHeight }">
        <div class="card-middle-inside" id="middle" ref="middle">
          <transition :name="transition" mode="out-in">
            <div class="" :key="$route.params.c + $route.params.q">
              <div class="box box-white">
                <h2>{{ survey[$route.params.survey].cat[$route.params.c].questions[$route.params.q].title }}</h2>
                <p v-if="survey[$route.params.survey].cat[$route.params.c].questions[$route.params.q].content">{{ survey[$route.params.survey].cat[$route.params.c].questions[$route.params.q].content }}</p>
                <div v-if="survey[$route.params.survey].cat[$route.params.c].questions[$route.params.q].readmore">
                  <div class="readmore" v-show="toggle" v-html="compiledMarkdown(survey[$route.params.survey].cat[$route.params.c].questions[$route.params.q].readmore)">

                  </div>
                  <p>
                    <a href="#" @click.prevent.default="goToggle()" v-show="!toggle" :class="{ active: toggle }" class="readmore">
                      Læs mere
                    </a>
                    <a href="#" @click.prevent.default="goToggle()" v-show="toggle" class="readmore-close">
                      Luk
                    </a>
                  </p>
                </div>
                <p v-if="!survey[$route.params.survey].cat[$route.params.c].questions[$route.params.q].radio">
                  Vælg gerne flere
                </p>
              </div>
              <div v-for="(a, aCount) in survey[$route.params.survey].cat[$route.params.c].questions[$route.params.q].answers" :key="a.id">
                <div v-if="survey[$route.params.survey].cat[$route.params.c].questions[$route.params.q].radio" class="radio">
                  <input @change="checkIfPicked" v-model="survey[$route.params.survey].cat[$route.params.c].questions[$route.params.q].picked"
                         name="multi" type="radio"
                         :id="'question'+aCount" :value="[aCount]">
                  <label :for="'question'+aCount">
                    <h6>{{a.title}}</h6>
                    <p v-if="a.subtitle">{{a.subtitle}}</p>
                  </label>
                </div>
                <div v-else class="checkbox">
                  <input @change="checkIfPicked" v-model="survey[$route.params.survey].cat[$route.params.c].questions[$route.params.q].picked"
                         :name="'multi'+aCount" type="checkbox"
                         :id="'question'+aCount" :value="aCount">
                  <label :for="'question'+aCount">
                    <h6>{{a.title}}</h6>
                    <p v-if="a.subtitle">{{a.subtitle}}</p>
                  </label>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-bottom">
        <div class="card-bottom-inside">
          <button class="btn-progress btn-prev" type="button" name="button" @click="prevPage"><span>Forrige</span></button>
          <div class="progress-bar ">
            <div class="progress-bar-inside" :style="{width: 'calc('+progress+'% - 8px)' }">

            </div>
          </div>
          <div class="progress-bar-mobile">
            <div class="progress-bar-inside-mobile" style="">
              <span>{{ Math.round(progress) }}%</span>
              <div class="">
                Gennemført
              </div>
            </div>
          </div>
          <button :disabled="!survey[$route.params.survey].cat[$route.params.c].questions[$route.params.q].oknext" class="btn-progress btn-next" type="button" name="button" @click="nextPage"><span>Næste </span></button>
        </div>
      </div>
    </div>
    <app-cfooter></app-cfooter>
  </div>
</template>

<script>
import qaheader from './modular/question-header.vue';
import Cfooter from '../components/modular/cfooter.vue';
import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';
import {db} from '../database/firebase';
import Marked from 'marked';

export default {
  name: 'Questions',
  components: {
    appQaheader: qaheader,
    appCfooter: Cfooter
  },
  beforeRouteUpdate (to, from, next) {
    let w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    let h;
    if(w > 1023){
      h = 405
    }else{
      h = 325
    }
    window.scrollTo(0, h);
    let self = this
    this.getHeight();
    setTimeout(function(){
      self.getWidth();
    }, 100);
    this.toggle = false;
    next();
  },
  data () {
    return {
      transition:"next",
      page: 0,
      qHeight:'auto',
      count:1,
      next:1,
      toggle:false,
    }
  },
  computed: {
    ...mapGetters([
      'survey',
      'firm',
      'globalC',
      'spinner',
      'surveyIsActive',
      'qaNumber',
      'answers',
      'progress'
    ]),

  },
  mounted() {
    if(!this.surveyIsActive){
      this.$router.push({ path: '/survey/'+ this.$route.params.survey })
    }
    this.getWidth();
    window.scrollTo(0, 0);
  },
  methods: {
    ...mapActions([
      'setNewAnswer',
      'avarage',
      'setPrev',
      'setProgress'
    ]),
    goToggle(){
      self.qHeight = "auto"
      this.toggle = !this.toggle;

    },
    getHeight(){
      let h = this.$refs.middle
      let self = this
      if(h){
        self.qHeight = h.clientHeight+'px'
        setTimeout(function(){
          self.qHeight = h.clientHeight+'px';
          console.log(h.clientHeight);
        }, 300)
      }

    },
    getWidth(){
      let w = Number(this.count)/Number(this.qaNumber[this.$route.params.survey]) * 100;
      this.setProgress(w);
    },
    compiledMarkdown(text) {
      return Marked(text, { sanitize: true })
    },
    checkIfPicked(){
      let s = this.$route.params.survey;
      let c = this.$route.params.c;
      let q = this.$route.params.q;


      if(this.survey[s].cat[c].questions[q].radio){
        this.survey[s].cat[c].questions[q].oknext = true;
      }else{
        if(!Object.keys(this.survey[s].cat[c].questions[q].picked).length){
          this.survey[s].cat[c].questions[q].oknext = false;
        }else{
          this.survey[s].cat[c].questions[q].oknext = true;
        }
      }

    },
    nextPage(){
      let s = this.$route.params.survey;
      let c = this.$route.params.c;
      let q = this.$route.params.q;

      if(this.survey[s].cat[c].questions[q].oknext){

        this.setNewAnswer([s, c, q, this.survey[s].cat[c].questions[q].picked, this.survey[s].cat[c].questions[q].radio]);

        // Logic for next and prev
        let nextOne = 1;
        if(this.survey[s].cat[c].questions[q].radio){
          nextOne = this.survey[s].cat[c].questions[q].answers[this.survey[s].cat[c].questions[q].picked].next
        }
        this.page = Number(q) + Number(nextOne)

        if(this.page < this.survey[s].cat[c].questions.length ){
          this.$router.push({ path: '/survey/'+s+'/c/'+c+'/q/'+ this.page })
          this.setPrev([s,c, Number(q) + Number(nextOne) , nextOne])
        }else{
          if(c < this.survey[s].cat.length - 1 ){
            this.$router.push({ path: '/survey/'+s+'/c/'+ (Number(c) + 1) +'/q/0' })
            this.setPrev([s,Number(c) + 1 ,0, nextOne])
          }else{
              this.$router.push({ path: '/resultat/'+s+'/' })
          }
        }
        this.count = this.count + Number(nextOne);

        this.transition = "next"
      }else{
        this.showModal = true;
      }


    },
    prevPage(){
      let s = Number(this.$route.params.survey);
      let c = Number(this.$route.params.c);
      let q = Number(this.$route.params.q);
      let prev = Number(this.survey[s].cat[c].questions[q].prev);
      let calculated = q-prev;
      this.count = this.count - prev;
      this.transition = "prev"

      if(calculated >= 0){
        this.$router.push({ path: '/survey/'+s+'/c/'+c+'/q/'+ calculated })
      }else{
        if(c > 0 ){
          let prev = Number(this.survey[s].cat[c].questions[q].prev);
          this.$router.push({ path: '/survey/'+s+'/c/'+(c-1)+'/q/'+ (this.survey[s].cat[Number(c - 1)].questions.length + calculated)})

        }else{
          this.$router.push({ path: '/survey/'+s })
        }
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
label >>> p{
  color:#fff;
  margin: 10px 0 0;
}
.card-bottom-inside{
  display: flex;
  justify-content: center;
  align-items: center;
  height:144px;
  margin-left: 30px;
  margin-right: 30px;
  max-width: calc(100% - 60px);
}
.progress-bar-mobile{
  display: none;
  text-align: center;
  font-size: 14px;
  margin-left: auto;
  margin-right: auto;
  & span{
    font-size: 30px;
    font-weight: 500;
    position: relative;
    top: -10px;

  }
  @media(max-width: 1023px){
    display: block;
  }
}
.progress-bar{
  @media(max-width: 1023px){
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Questions.vue